import { render } from "./ListService.vue?vue&type=template&id=384f192e&scoped=true"
import script from "./ListService.vue?vue&type=script&lang=js"
export * from "./ListService.vue?vue&type=script&lang=js"

import "./ListService.vue?vue&type=style&index=0&id=384f192e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-384f192e"]])

export default __exports__